// Swift `trimmingCharacters(in:)` with Foundation's character sets (shared with the GPX module).

import { isWhitespace, trimCharacters, trimWhitespaceAndNewlines } from '../gpx/internal';

export { trimWhitespaceAndNewlines };

/** Swift `trimmingCharacters(in: .whitespaces)` (spaces and tabs, not line breaks). */
export function trimWhitespace(s: string): string {
  return trimCharacters(s, isWhitespace);
}
